module.exports = __webpack_public_path__ + "img/non-laminated.a659ae3.svg";